import * as ce from "./custom_errors";

import { marked } from "marked";
import DOMPurify from "dompurify";
import { parse, ARR, OBJ } from "partial-json";

// export async function parseHtmlTextOLD(text: string): Promise<string> {
//   try {
//     let parsedText = text.replace("```html", "").replace("```json", "").replace("```", "");
//     parsedText = await marked(parsedText);
//     parsedText = DOMPurify.sanitize(parsedText);
//     return parsedText;
//   } catch (e) {
//     console.error(e);
//     console.warn("Error parsing HTML");
//     return text;
//   }
// }

export async function parseHtmlTextOLD(text: string): Promise<string> {
  try {
    const trimmedText = text.trim();
    const withoutOpening = trimmedText.replace(/^```(?:\s*(html|json))?\s*/i, "");
    const withoutCodeBlock = withoutOpening.replace(/```$/i, "");

    // Markdown -> HTML
    const parsedText = await marked(withoutCodeBlock);

    const sanitizedText = DOMPurify.sanitize(parsedText);

    return sanitizedText;
  } catch (e) {
    console.error("Error parsing HTML:", e);
    return text;
  }
}

export async function parseHtmlText(text: string): Promise<string> {
  try {
    const trimmedText = text.trim();

    const withoutCodeFence = trimmedText
      .replace(/^```(?:\s*(html|json))?\s*/i, "")
      .replace(/```$/i, "")
      .trim();

    // check if text is probably HTML
    const isProbablyHtml = /<\/?[a-z][\s\S]*>/i.test(withoutCodeFence);

    let html: string;

    if (isProbablyHtml) {
      html = withoutCodeFence;
    } else {
      html = await marked(withoutCodeFence);
    }

    const safeHtml = DOMPurify.sanitize(html);

    return safeHtml;
  } catch (e) {
    console.error("Error parsing HTML:", e);
    return text;
  }
}

export function parseJson(text: string): Record<string, any> {
  try {
    let parsedText = text
      .replace("```json", "")
      .replace("```", "")
      .replaceAll(/[\r\n]/g, "");
    let parsedJson = parse(parsedText, ARR | OBJ);
    try {
      parsedJson = parse(parsedJson, ARR | OBJ);
    } catch (e) {}
    return parsedJson;
  } catch (e) {
    throw new ce.ParseJsonError("Error parsing JSON");
  }
}

export function toAnyString(value: unknown): string {
  if (typeof value === "object" && value !== null) {
    return JSON.stringify(value, null, 2);
  }
  return String(value);
}
